export const selectCompanyId = store => store.company.currentCompany?.id;
export const selectCompany = store => store.company.currentCompany;
export const selectCompanyError = store =>
  store.company.currentCompany?.selectCompanyError;
export const selectNextIntegration = store => store.company.nextIntegration;
export const selectCompanySettings = store =>
  store.company.currentCompany?.settings;
export const selectCompanyCountryCode = store => store.company.currentCompany.countryCode;
